export default "__VITE_ASSET__xkgWmRnE__"